module.exports = __webpack_public_path__ + "static/media/guide-smell-2.b7b6cc8e.svg";